import type { SVGProps } from 'react'
const SvgSyChartAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<rect width={18} height={18} x={3} y={3} fillOpacity={0.24} rx={2} />
		<path d="M17.934 7.404a.6.6 0 0 0-.403.221l-3.58 4.477-2.41-2.41a.76.76 0 0 0-1.107.05l-4.895 5.873a.6.6 0 0 0 .076.846.6.6 0 0 0 .846-.076l4.578-5.496 2.418 2.418a.76.76 0 0 0 1.115-.063l3.897-4.869a.6.6 0 0 0-.094-.844.6.6 0 0 0-.441-.127" />
	</svg>
)
export default SvgSyChartAlt
